import { render, staticRenderFns } from "./GuiaEdicao.vue?vue&type=template&id=57ba2950&scoped=true&"
import script from "./GuiaEdicao.vue?vue&type=script&lang=js&"
export * from "./GuiaEdicao.vue?vue&type=script&lang=js&"
import style0 from "./GuiaEdicao.vue?vue&type=style&index=0&id=57ba2950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba2950",
  null
  
)

export default component.exports